module.exports = __webpack_public_path__ + "img/Weapon_218.be5785ee.png";